import { render } from "./SelectField.vue?vue&type=template&id=b8a216de&scoped=true"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"

import "./SelectField.vue?vue&type=style&index=0&id=b8a216de&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a216de"]])

export default __exports__